// eslint-disable-next-line no-var
var Json = /** @class */ (function () {
	function Json() {
	}
	Json.serializ = function (content) {
		return JSON.stringify(content);
	};
	Json.deSerializ = function (content) {
		// eslint-disable-next-line no-var
		var result = null;
		if (content) {
			result = JSON.parse(content);
		}
		return result;
	};
	return Json;
}());
// eslint-disable-next-line semi
export { Json }
